var _rect, _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSketchupDark(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 256,
    height: 256,
    viewBox: "0 0 256 256",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 256,
    height: 256,
    rx: 60,
    fill: "#242938"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M160.016 19L28 36.2041V37.2009L47.0704 151.19L74.1723 236.225L213.439 196.568L228 72.3478L160.016 19ZM156.477 32.1921L211.349 75.317L162.589 84.0853L132.828 53.113L49.9625 65.1816L42.4054 47.0874L156.477 32.1921ZM133.954 86.5013L162.196 121.732L116.415 131.477L105.474 112.644L63.3113 120.856L55.6685 100.339L133.954 86.5013ZM108.611 149.983L118.995 170.418L76.6799 180.955L69.1916 158.989L108.611 149.983Z",
    fill: "#E7242D"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSketchupDark);
export default __webpack_public_path__ + "static/media/Sketchup-Dark.ad2c3bef0084bb32cd58f63c56d6ad09.svg";
export { ForwardRef as ReactComponent };